import { render } from "./Register.vue?vue&type=template&id=3bba7074&scoped=true"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"

import "./Register.vue?vue&type=style&index=0&id=3bba7074&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3bba7074"

export default script